import type { GetIsPeriodCurrentMonthParams } from '../types';

const getIsPeriodCurrentMonth = ({ month, now }: GetIsPeriodCurrentMonthParams): boolean => {
    const [yearText, monthText] = month.split('-');
    return now.getUTCFullYear() === Number(yearText) && now.getUTCMonth() === Number(monthText) - 1;
};

export default getIsPeriodCurrentMonth;
